import { Injectable } from "@angular/core";

import { Observable, BehaviorSubject } from "rxjs";

import { AppStorageService, StorageLocation } from "@core/app-store/app-storage.service";

import { ThemeHelper } from "@shared/helpers/theme/theme.helper";

@Injectable({ providedIn: 'root' })
export class LayoutService {

    private modeTheme$$ = new BehaviorSubject<string>(ThemeHelper.getSmartAdmin() ?? '');
    public themeMode$: Observable<string> = this.modeTheme$$.asObservable();

    constructor(
        private readonly storageService: AppStorageService,
    ) { }

    setThemeMode(mode: string) {
        this.storageService.setItem(
            this.storageService.localStorageKeys.global.layouts.currentThemeMode,
            mode,
            { location: StorageLocation.LOCAL_STORAGE }
        );
        this.modeTheme$$.next(mode);
    }

}